import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Label } from "@atoms/label";
import { PhoneInput } from "@components/formControl/phoneInput/phoneInput";
import { PHONE_CODE_OPTIONS } from "@constants";

import type { IValue } from "../types";

import type { IFastPhoneProps } from "./types";

export function FastPhone<TSchema extends object>(
  props: IFastPhoneProps<TSchema>,
) {
  const {
    control,
    name,
    type,
    isRequired,
    onChange: propsOnChange,
    noLabel,
  } = props;

  const { t } = useTranslation("field");

  const title = t(type);

  const inputController = (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onBlur, ref, onChange, value, disabled },
        fieldState: { error, invalid },
      }) => (
        <PhoneInput
          options={PHONE_CODE_OPTIONS}
          value={value}
          id={name}
          onValueChange={(value) => {
            onChange(value);
            propsOnChange?.(value as IValue<TSchema>);
          }}
          onBlur={onBlur}
          ref={ref}
          disabled={disabled}
          placeholder={title}
          isInvalid={invalid}
          hintText={error?.message}
        />
      )}
    />
  );

  return (
    <>
      {noLabel && inputController}
      {!noLabel && (
        <Label text={title} htmlFor={name} isRequired={isRequired}>
          {inputController}
        </Label>
      )}
    </>
  );
}
